import Snackbar from "awesome-snackbar";

import { Translations, i18n } from "../i18n";
import { theme } from "../layout";

const show = (messageProp?: string) => {
  const message = messageProp ?? i18n.t(Translations.ErrorBannerDefaultMessage);

  new Snackbar(`<p class="errorBanner">${message}</p>`, {
    position: "bottom-center",
    style: {
      container: [["background-color", theme.error.background]],
    },
  });
};

export const ErrorBanner = { show };
